// This function allow to reference async chunks
__webpack_require__.u = function(chunkId) {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"787":"19cfaf89","810":"0dc14cb0","937":"15277ede"}[chunkId] + ".chunk.js";
};